import apiClient from '@/services/api';
import { useAuthStore } from '@/stores/auth';

const sanitizeTenant = (t) => {
  const d = { ...t };
  const authStore = useAuthStore();
  d.company_id = d.company_id || authStore.currentUser?.company_id;

  // if (d.date_of_birth) d.date_of_birth = d.date_of_birth.substring(0,10); // keep YYYY-MM-DD
  if (d.status) d.status = d.status.toLowerCase();        // active | inactive

  const formatDate = (date) => {
    if (!date) return null;
    if (date instanceof Date) return date.toISOString().split('T')[0];
    return date;
  };
  d.date_of_birth = formatDate(d.date_of_birth);
  return d;
};

export default {
  
  async getTenants() {
    const authStore = useAuthStore();
    const userCompanyId = authStore.currentUser?.company_id;
    
    // Build URL with company filter if user has a company_id
    let url = '/tenants';
    if (userCompanyId) {
      const filter = {"field":"company_id","value":userCompanyId};
      url += `?filter=${encodeURIComponent(JSON.stringify(filter))}`;
    }
    
    return (await apiClient.get(url)).data;
  },

  async getTenant(id) {
    return (await apiClient.get(`/tenants/${id}`)).data;
  },

  async createTenant(tenantData) {
    const dataToSend = sanitizeTenant(tenantData);
    return (await apiClient.post('/tenants', dataToSend)).data;
  },

  async updateTenant(id, tenantData) {
    const dataToSend = sanitizeTenant(tenantData);
    return (await apiClient.put(`/tenants/${id}`, dataToSend)).data;
  },

  async deleteTenant(id) {
    return (await apiClient.delete(`/tenants/${id}`)).data;
  }
};